import { ApolloClient, NormalizedCacheObject } from 'apollo-boost'
import { ClientBehaviours } from '../../utils'
import { product } from '../../../graphql/Query/Product/Product.graphql'
import {
  Currency,
  Product as HorizonProduct,
  ProductImage,
  ProductPrice,
  ProductReviews,
  ProductVariant,
} from '../../../generated/graphql'
import { ProductType } from '../../../../types/enterpriseTypes'
import { mergeVariantProduct } from '../../../transformers/product'

export const MOCK_PRODUCT = {
  sku: 10485098,
  title: 'Shaker',
  url: '/bobbi-brown-skin-foundation-spf15-30ml-various-shades/11519360.html',
  images: [
    {
      thumbnail:
        'https://s1.thcdn.com/productimg/70/70/10485098-9444620643710144.jpg',
      largeProduct:
        'https://s1.thcdn.com/productimg/300/300/10485098-9444620643710144.jpg',
      zoom:
        'https://s1.thcdn.com/productimg/960/960/10485098-9444620643710144.jpg',
      __typename: 'ProductImage',
    },
    {
      thumbnail:
        'https://s1.thcdn.com/productimg/70/70/10485098-1284620643753431.jpg',
      largeProduct:
        'https://s1.thcdn.com/productimg/300/300/10485098-1284620643753431.jpg',
      zoom:
        'https://s1.thcdn.com/productimg/960/960/10485098-1284620643753431.jpg',
      __typename: 'ProductImage',
    },
    {
      thumbnail:
        'https://s1.thcdn.com/productimg/70/70/10485098-4684620643797264.jpg',
      largeProduct:
        'https://s1.thcdn.com/productimg/300/300/10485098-4684620643797264.jpg',
      zoom:
        'https://s1.thcdn.com/productimg/960/960/10485098-4684620643797264.jpg',
      __typename: 'ProductImage',
    },
  ],
  variants: [
    {
      sku: 10485098,
      title: 'Testofen® Capsules variant',
      images: [
        {
          thumbnail:
            'https://s1.thcdn.com/productimg/70/70/10485098-1284620643753431.jpg',
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/10485098-1284620643753431.jpg',
          zoom:
            'https://s1.thcdn.com/productimg/960/960/10485098-1284620643753431.jpg',
          __typename: 'ProductImage',
        },
      ],
      price: {
        price: {
          displayValue: `£7.99`,
          amount: '7.99',
          currency: Currency.Gbp,
          scalarValue: 'GBP7.99',
          __typename: 'MoneyValue' as 'MoneyValue',
        },
        rrp: {
          displayValue: `£45.99`,
          amount: '45.99',
          currency: Currency.Gbp,
          scalarValue: 'GBP45.99',
          __typename: 'MoneyValue' as 'MoneyValue',
        },
        __typename: 'ProductPrice' as 'ProductPrice',
      },
      gbpPrice: {
        price: {
          displayValue: `£7.99`,
          amount: '7.99',
          currency: Currency.Gbp,
          scalarValue: 'GBP7.99',
          __typename: 'MoneyValue' as 'MoneyValue',
        },
        rrp: {
          displayValue: `£45.99`,
          amount: '45.99',
          currency: Currency.Gbp,
          scalarValue: 'GBP45.99',
          __typename: 'MoneyValue' as 'MoneyValue',
        },
        __typename: 'ProductPrice' as 'ProductPrice',
      },
      content: [
        {
          key: 'brand',
          value: {
            __typename: 'ProductContentStringListValue',
          },
          __typename: 'ProductContentItem',
        },
        {
          key: 'synopsis',
          value: {
            value: [
              {
                content: [
                  {
                    content: '<p>Variant Description</p>\n',
                    __typename: 'RichContentItem',
                  },
                ],
                __typename: 'RichContent',
              },
            ],
            __typename: 'ProductContentRichContentListValue',
          },
          __typename: 'ProductContentItem',
        },
        {
          key: 'volume',
          value: {
            __typename: 'ProductContentStringListValue',
          },
          __typename: 'ProductContentItem',
        },
        {
          key: 'directions',
          value: {
            __typename: 'ProductContentRichContentValue',
          },
          __typename: 'ProductContentItem',
        },
      ],
      __typename: 'ProductVariant',
    },
    {
      sku: 11447792,
      title: 'Testofen® Capsules variant cheaper',
      images: [
        {
          thumbnail:
            'https://s1.thcdn.com/productimg/70/70/10485098-1284620643753431.jpg',
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/10485098-1284620643753431.jpg',
          zoom:
            'https://s1.thcdn.com/productimg/960/960/10485098-1284620643753431.jpg',
          __typename: 'ProductImage',
        },
      ],
      price: {
        price: {
          displayValue: `£5.99`,
          amount: '5.99',
          currency: Currency.Gbp,
          scalarValue: 'GBP5.99',
          __typename: 'MoneyValue' as 'MoneyValue',
        },
        rrp: {
          displayValue: `£45.99`,
          amount: '45.99',
          currency: Currency.Gbp,
          scalarValue: 'GBP45.99',
          __typename: 'MoneyValue' as 'MoneyValue',
        },
        __typename: 'ProductPrice' as 'ProductPrice',
      },
      gbpPrice: {
        price: {
          displayValue: `£5.99`,
          amount: '5.99',
          currency: Currency.Gbp,
          scalarValue: 'GBP5.99',
          __typename: 'MoneyValue' as 'MoneyValue',
        },
        rrp: {
          displayValue: `£45.99`,
          amount: '45.99',
          currency: Currency.Gbp,
          scalarValue: 'GBP45.99',
          __typename: 'MoneyValue' as 'MoneyValue',
        },
        __typename: 'ProductPrice' as 'ProductPrice',
      },
      content: [],
      __typename: 'ProductVariant',
    },
  ],
  reviews: {
    total: 6,
    averageScore: 4.83,
    __typename: 'ProductReviews',
  },
  content: [
    {
      key: 'brand',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'npdTag',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'Diet',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'gender',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'proteinGoals',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'searchKeywords',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'brandKey',
      value: {
        __typename: 'ProductContentStringValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'proteinCategory',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'whyChoose',
      value: {
        richContentValue: {
          content: [
            {
              content:
                '<h3><strong>What are the Benefits of Impact Whey Protein?</strong></h3> \n<p>It provides your body with convenient, high-quality protein, which contributes to the growth and maintenance of muscle mass — making sure you’re getting the protein you need, each and every day.</p> \n<p>It also includes 3.6g of glutamine and all the essential amino acids, including 4.5g of BCAAs — these naturally occur in protein which helps to build and repair new muscle<sup>1</sup> — so you’re always ready for the next session. Check out the full amino acid profile <a href="https://s1.thcdn.com/design-assets/documents/myprotein/ImpactWheyProtein.pdf" target="_blank"><strong>here</strong></a>.</p> \n<p>With just 1.9g of fat, 1g of carbs, and at just 103 calories per serving, Impact Whey Protein is perfect for everyone, whatever your fitness goals.</p> \n<p>And it comes in a range of indulgent, mouth-watering flavours, too!</p> \n<h3><strong>What Does Impact Whey Protein Taste Like?</strong></h3> \n<p>Impact Whey Protein comes in a range of mouth-watering flavours. We’ve got everything, from the classics Chocolate Smooth, Strawberry Cream, and Vanilla, limited edition flavours and the taste of some of your favourite deserts — there’s something for everyone.</p> \n<p>And, if you prefer a more natural taste, we’ve got a range of stevia flavoured options too.</p> \n<h3><strong>What is the Best Whey Protein?</strong></h3> \n<p>Whey protein is considered to be a complete protein, as it contains all 9 essential amino acids, but there’s not just one type of whey.</p> \n<p>There are three types of whey protein — whey protein concentrate, whey protein isolate, and hydrolysed whey — each with varying protein, lactose, and fat contents.</p> \n<h3><strong>Whey Protein Concentrate (Impact Whey Protein)</strong></h3> \n<p>Whey protein concentrate is on average around 70-80% protein, with a moderate fat content. Our popular Impact Whey Protein provides over 80% protein per serving, so you can be assured of its quality.</p> \n<h3><strong>Whey Protein Isolate (Impact Whey Isolate)</strong></h3> \n<p>Whey isolate is a form of protein that’s been highly refined for purity — resulting in a high protein content, with low sugar and zero fat. Our <a href="/sports-nutrition/impact-whey-isolate/10530911.html">Impact Whey Isolate</a> is one of the purest powders available with a 90% protein content.</p> \n<h3><strong>Hydrolysed Whey (Hydrolysed Whey Protein)</strong></h3> \n<p>Created in a unique way that can speed up its absorption into your body — while keeping the essential amino acids intact and delivering a high-quality protein.</p> \n<h3><strong>Quality Assurance</strong></h3> \n<p>There’s simply not another protein powder out there that delivers the same outstanding quality and value. And that’s because it’s created in our own state-of-the-art production facility, where we develop superior products in-house and deliver direct – cutting out the costs to pass the savings onto you.</p> \n<p><span style="font-size:10px">*</span>Myprotein brand health survey, Attest platform, UK market, September 2020 data</p> \n<p><span style="font-size:10px">*Nutritionals based on Unflavoured</span></p> \n<p><span style="font-size:10px">1. Protein contributes to the growth and maintenance of muscle mass.</span></p>',
              __typename: 'RichContentItem',
            },
          ],
          __typename: 'RichContent',
        },
        __typename: 'ProductContentRichContentValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'packageComposition',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'subtitle',
      value: {
        richContentValue: {
          content: [
            {
              content: "The UK's favourite brand* of protein powder",
              __typename: 'RichContentItem',
            },
          ],
          __typename: 'RichContent',
        },
        __typename: 'ProductContentRichContentValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'protein',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'suggestedUse',
      value: {
        richContentValue: {
          content: [
            {
              content:
                '<h3><strong>When to take Impact Whey Protein?</strong></h3> \n<p>It’s fast absorbing, so we recommend adding 1 large scoop (25g) to 150-250ml of water or milk 30-60 minutes post-workout — but it’s ideal any time for a convenient way to get the protein you need.</p> \n<h3><strong>What does Impact Whey Protein work well with?</strong></h3> \n<p>Get some extra help to power through that difficult last set — add a scoop of <a href="/sports-nutrition/creatine-monohydrate/10530050.html">Creatine Monohydrate</a> to your shake — it’s proven to increase physical performance in successive bursts of short-term, high-intensity exercise.2</p> \n<p><span style="font-size:10px">2. Creatine is proven to improve physical performance in successive bursts of short-term, high-intensity exercise. The beneficial effect is obtained with a daily intake of 3g creatine.</span></p> \n<p><span style="font-size:10px">Store in a cool, dry place away from direct sunlight. This product is intended to be used alongside an active lifestyle and a balanced diet. Suitable for vegetarians.</span></p>',
              __typename: 'RichContentItem',
            },
          ],
          __typename: 'RichContent',
        },
        __typename: 'ProductContentRichContentValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'metaDataDesc',
      value: {
        richContentValue: {
          content: [
            {
              content:
                "Impact Whey Protein is the UK's #1 Premium Whey Protein with over 80% protein per serving. More than 50 mouth-watering flavours available.",
              __typename: 'RichContentItem',
            },
          ],
          __typename: 'RichContent',
        },
        __typename: 'ProductContentRichContentValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'sportsSubCategory',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'proteinProducttype',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'sportsCategory',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'ebayProductTitle',
      value: {
        __typename: 'ProductContentStringValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'nutritionalInfo',
      value: {
        richContentValue: {
          content: [
            {
              content:
                '<p><strong>Chocolate</strong></p> \n<p><strong>Serving Size</strong> - 1 Packet (35g)</p> \n<p><strong>Servings Per Container</strong> - 10 Packs</p> \n<div> \n <h2>Nutritional Information</h2> \n <table border=""> \n  <thead> \n   <tr> \n    <td colspan="">&nbsp;</td> \n    <td><strong>Per 100 g</strong></td> \n    <td><strong>Per Serving (35 g)</strong></td> \n   </tr> \n  </thead> \n  <tbody> \n   <tr> \n    <td colspan=""><strong>Energy</strong></td> \n    <td>1895 kJ/451 kcal</td> \n    <td>664 kJ/158 kcal</td> \n   </tr> \n   <tr> \n    <td colspan=""><strong>Fat</strong></td> \n    <td>18 g</td> \n    <td>6.2 g</td> \n   </tr> \n   <tr> \n    <td colspan="">of which saturates</td> \n    <td>14 g</td> \n    <td>4.9 g</td> \n   </tr> \n   <tr> \n    <td colspan=""><strong>Carbohydrate</strong></td> \n    <td>29 g</td> \n    <td>10 g</td> \n   </tr> \n   <tr> \n    <td colspan="">of which sugars</td> \n    <td>17 g</td> \n    <td>5.8 g</td> \n   </tr> \n   <tr> \n    <td colspan=""><strong>Fibre</strong></td> \n    <td>2.9 g</td> \n    <td>1.0 g</td> \n   </tr> \n   <tr> \n    <td colspan=""><strong>Protein</strong></td> \n    <td>43 g</td> \n    <td>15 g</td> \n   </tr> \n   <tr> \n    <td colspan=""><strong>Salt</strong></td> \n    <td>0.08 g</td> \n    <td>0.02 g</td> \n   </tr> \n  </tbody> \n </table> \n</div>',
              __typename: 'RichContentItem',
            },
          ],
          __typename: 'RichContent',
        },
        __typename: 'ProductContentRichContentValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'nutritionType',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'ingredients',
      value: {
        richContentValue: {
          content: [
            {
              content:
                '<p>For allergens, see ingredients in&nbsp;<strong>bold</strong>. May also contain egg.</p> \n<p><em>Apple Crumble &amp; Custard Flavour</em>:&nbsp;Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Colour (E160a), Sweetener (Sucralose)</p> \n<p><em>Banana Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Flavouring, Colour (Curcumin), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Sweetener (Sucralose)</p> \n<p><em>Banoffee Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Malt Extract (<strong>Barley</strong>), Sweetener (Sucralose)</p> \n<p><em>Blueberry Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Natural Flavouring (<strong>Sulphites</strong>), Colour (Beetroot Red, Anthocyanin), Acid (Citric Acid), Sweetener (Sucralose)</p> \n<p><em>Blueberry Cheesecake Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Colour (Beetroot Red), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Chocolate Banana Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Cocoa Powder, Flavouring, Sweetener (Sucralose)</p> \n<p><em>Chocolate Brownie Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Fat Reduced Cocoa Powder, Flavouring, Sweetener (Sucralose)</p> \n<p><em>Chocolate Caramel Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy</strong> Lecithin), Cocoa Powder, Flavouring (Flavouring, Malt Powder (<strong>Barley</strong>),Sweetener (Sucralose))</p> \n<p><em>Chocolate Cereal Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Cocoa Powder, Flavouring, Sweetener (Sucralose).</p> \n<p><em>Chocolate Coconut Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (92%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Colour (E150c), Acidity Regulator (Malic Acid), Sweetener (Sucralose)</p> \n<p><em>Chocolate Mint Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (92%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Fat Reduced Cocoa Powder, Sweetener (Sucralose), Flavouring</p> \n<p><em>Chocolate Nut Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Cocoa Powder, Flavouring, Sweetener (Sucralose)</p> \n<p><em>Chocolate Orange Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Cocoa Powder, Flavouring, Sweetener (Sucralose)</p> \n<p><em>Chocolate Peanut Butter Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Cocoa Powder, Flavouring, Sweetener (Sucralose)</p> \n<p><em>Chocolate Smooth Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy </strong>Lecithin), Natural and Artificial Flavouring (Cocoa Powder, Maltodextrin, Sweeteners (Sucralose, Acesulfame K))&nbsp;</p> \n<p><em>Cinnamon Danish Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (95%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Colour (E150a), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Cinnamon Roll Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (95%), Flavouring, Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Sweetener (Sucralose), Salt.</p> \n<p><em>Coffee Caramel Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Colour (E150a), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Cookies &amp; Cream Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Fruity Cereal Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Sweetener (Sucralose).</p> \n<p><em>Golden Syrup Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Latte Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Malt Extract(<strong>Barley</strong>), Sweetener (Sucralose)</p> \n<p><em>Lemon Cheesecake Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Maple Syrup Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Matcha&nbsp;Flavour</em>: Whey Protein Concentrate (93%) (<strong>Milk</strong>, Emulsifier (<strong>Soy&nbsp;</strong>Lecithin)), Matcha Green Tea Powder (4%), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Milk Tea Flavour</em>: Whey Protein Concentrate (94%) (Whey Protein Concentrate (<strong>Milk</strong>), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin)), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Mocha Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Cocoa Powder, Flavouring, Sweetener (Sucralose)</p> \n<p><em>Natural Banana Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Natural Flavouring, Colour (Curcumin), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Sweetener (Sucralose)</p> \n<p><em>Natural Banoffee Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Natural Flavouring, Malt Extract, Sweetener (Sucralose)</p> \n<p><em>Natural Chocolate Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Cocoa Powder, Flavouring, Sweetener (Sucralose)</p> \n<p><em>Natural Strawberry Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (95%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Natural Flavouring, Colour (Beetroot Red), Sweetener (Sucralose)</p> \n<p><em>Natural Vanilla Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Natural Flavouring, Sweetener (Sucralose)</p> \n<p><em>Neapolitan Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Fat Reduced Cocoa Powder, Flavouring, Sweetener (Sucralose)</p> \n<p><em>Orange Cream Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Colour (Carotenes), Sweetener (Sucralose).</p> \n<p><em>Peanut Cookie Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Colour (E150a), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Peach Tea&nbsp;Flavour</em>: Whey Protein Concentrate (<strong>Milk, Soy</strong>) (97%), Natural&nbsp;Flavouring (Natural Flavouring,&nbsp;Sweetener (Sucralose))</p> \n<p><em>Pecan Pie Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Colour (E150a), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Pineapple Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Colour (Curcumin), Sweetener (Sucralose)</p> \n<p><em>Raspberry Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Acid (Citric Acid), Colour (Beetroot Red), Purple Carrot Extract, Sweetener (Sucralose)</p> \n<p><em>Rhubarb &amp; Custard Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Colour (Beetroot Red), Sweetener (Sucralose)</p> \n<p><em>Rocky Road Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (90%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Cocoa Powder, Flavouring, Sweetener (Sucralose)</p> \n<p><em>Salted Caramel Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Colour (E150c), Sweetener (Sucralose)</p> \n<p><em>Stevia Banana Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Natural Flavouring, Colour (Curcumin), Sweetener (Steviol Glycosides)</p> \n<p><em>Stevia Blueberry &amp; Raspberry Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (90%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Natural Flavouring (<strong>Sulphites</strong>), Colour (Beetroot Red, Anthocyanin), Sweetener (Steviol Glycosides)</p> \n<p><em>Stevia Chocolate Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Cocoa Powder, Flavouring, Sweetener (Steviol Glycosides)</p> \n<p><em>Stevia Chocolate Mint Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Cocoa Powder, Natural Flavouring, Sweetener (Steviol Glycosides)</p> \n<p><em>Stevia Strawberry Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Colour (Beetroot Red), Sweetener (Steviol Glycosides)</p> \n<p><em>Stevia Vanilla Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Natural Flavouring, Sweetener (Steviol Glycosides)</p> \n<p><em>Sticky Toffee Pudding Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Colour (E150c), Sweetener (Sucralose)</p> \n<p><em>Stracciatella Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Cocoa Powder, Flavouring (<strong>Milk</strong>), Sweetener (Sucralose)</p> \n<p><em>Strawberry Cream Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Colour (Beetroot Red), Sweetener (Sucralose)</p> \n<p><em>Strawberry Jam Roly Poly Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Colour (Beetroot Red), Acid (Citric Acid), Sweetener (Sucralose)</p> \n<p><em>Summer Fruit Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Acid (Citric Acid), Colour (Beetroot Red, Curcumin), Sweetener (Sucralose)</p> \n<p><em>Tiramisu Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (91%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Cocoa Powder, Flavouring, Colour (E150c), Sweetener (Sucralose)</p> \n<p><em>Unflavoured</em>: Whey Protein Concentrate (<strong>Milk</strong>) (100%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin)</p> \n<p><em>Vanilla Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Vanilla Raspberry Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Colours (E162, E163), Sweetener (Sucralose)</p> \n<p><em>White Chocolate Flavour</em>: Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong>&nbsp;Lecithin), Flavouring, Sweetener (Sucralose)</p> \n<p><em>Chocolate Cake Flavour</em>: Whey Protein Concentrate (Contains&nbsp;<strong>Milk</strong>&nbsp;and&nbsp;<strong>Soy</strong>) (93%), Flavouring (Cocoa Powder, Flavouring, Sweetener (Sucralose)).</p> \n<p><em>Victoria Sponge Cake Flavour</em>: Whey Protein Concentrate (Contains&nbsp;<strong>Milk</strong>&nbsp;and&nbsp;<strong>Soy</strong>) (95%), Flavouring (Flavouring, Salt, Sweetener (Sucralose)).</p> \n<p><em>Birthday Cake Flavour</em>: Whey Protein Concentrate (Contains&nbsp;<strong>Milk,</strong>&nbsp;and&nbsp;<strong>Soy</strong>) (92%), Sprinkles (Sugar,&nbsp;<strong>Wheat</strong>&nbsp;Starch, Water, Glucose Syrup, Beetroot Concentrate, Vegetable Oil, Colours (Anthocyanins, Curcumin), Glazing Agent (Beeswax)), Flavouring, Sweetener (Sucralose)).</p> \n<p>Rainbow Flavour:&nbsp;Whey Protein Concentrate (<strong>Milk</strong>) (96%), Emulsifier (<strong>Soy</strong> Lecithin), Colour (Beetroot Red), Flavourings, Curcuma Oil Extract, Sweetener (Sucralose).</p> \n<p><em>Milk Tea Flavour</em>:&nbsp;Whey Protein Concentrate (94%) (Whey Protein Concentrate (Milk), Emulsifier (Soy Lecithin)), Flavouring, Sweetener (Sucralose).</p>',
              __typename: 'RichContentItem',
            },
          ],
          __typename: 'RichContent',
        },
        __typename: 'ProductContentRichContentValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'googleAdwordsGroup',
      value: {
        __typename: 'ProductContentStringValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'allergens',
      value: {
        richContentValue: {
          content: [
            {
              content:
                '<p>For allergens, see ingredients in <strong>bold</strong>. May also contain egg.</p>',
              __typename: 'RichContentItem',
            },
          ],
          __typename: 'RichContent',
        },
        __typename: 'ProductContentRichContentValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'metaDataKeywords',
      value: {
        __typename: 'ProductContentStringValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'googleCustomLabel0',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'title',
      value: {
        __typename: 'ProductContentStringValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'nutritionProducttype',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'productTitle',
      value: {
        __typename: 'ProductContentStringValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'synopsis',
      value: {
        value: [
          {
            content: [
              {
                content:
                  '<p><span style="font-size:10px">Nutritional information may</span><span style="font-size:10px">&nbsp;vary depending on flavour.</span></p> \n<h2>What is Impact Whey Protein?</h2> \n<p>Premium whey packed with 21g of protein per serving, for the everyday protein you need from a quality source.</p> \n<p>And where does this whey come from? The same cows that produce your milk and cheese — simply filtered, evaporated, and spray-dried to produce all-natural nutritionals.</p> \n<p>Ranked Grade A by independent tester Labdoor for both quality and value, Impact Whey Protein is officially certified as one of the best protein powders on the market.</p> \n<p>Get yours in over 40 flavours, with delicious favourites including Chocolate, Vanilla, and Strawberry Cream.</p> \n<p>Want more information on protein powder, its benefits, and guidance on which one\'s best for you? Check out our <a href="https://catalogue.thehutgroup.com/myprotein/the-protein-guide/en" target="_blank"><strong>Protein Guide</strong></a>.</p>',
                __typename: 'RichContentItem',
              },
            ],
            __typename: 'RichContent',
          },
        ],
        __typename: 'ProductContentRichContentListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'keyBenefits',
      value: {
        richContentValue: {
          content: [
            {
              content:
                '<ul> \n <li>21g protein per serving*</li> \n <li>4.5g naturally-occurring BCAAs</li> \n <li>Low in sugar*</li> \n <li>Over 40 delicious flavours</li> \n</ul> \n<p><span style="font-size:10px">Nutritional information may</span><span style="font-size:10px">&nbsp;vary depending on flavour.</span></p>',
              __typename: 'RichContentItem',
            },
          ],
          __typename: 'RichContent',
        },
        __typename: 'ProductContentRichContentValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'metaDataTitle',
      value: {
        __typename: 'ProductContentStringValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'productCategory',
      value: {
        __typename: 'ProductContentStringListValue',
      },
      __typename: 'ProductContentItem',
    },
    {
      key: 'certificateOfAnalysis',
      value: {
        __typename: 'ProductContentStringValue',
      },
      __typename: 'ProductContentItem',
    },
  ],
  recommendations: [
    {
      sku: 10530943,
      url: '/sports-nutrition/impact-whey-protein/10530943.html',
      title: 'Impact Whey Protein',
      images: [
        {
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/10530943-1504726884876366.jpg',
          __typename: 'ProductImage',
        },
        {
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/10530943-5604726884979938.jpg',
          __typename: 'ProductImage',
        },
      ],
      variants: [
        {
          price: {
            price: {
              displayValue: '£109.99',
              amount: '109.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£109.99',
              amount: '109.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£59.99',
              amount: '59.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£59.99',
              amount: '59.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£26.99',
              amount: '26.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£26.99',
              amount: '26.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£9.99',
              amount: '9.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£9.99',
              amount: '9.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£12.99',
              amount: '12.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£12.99',
              amount: '12.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£23.99',
              amount: '23.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£23.99',
              amount: '23.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
      ],
      reviews: {
        total: 20294,
        averageScore: 4.6,
        __typename: 'ProductReviews',
      },
      __typename: 'Product',
    },
    {
      sku: 12081395,
      url: '/sports-nutrition/clear-whey-isolate/12081395.html',
      title: 'Clear Whey Isolate',
      images: [
        {
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/12457913-3554790136840897.jpg',
          __typename: 'ProductImage',
        },
      ],
      variants: [
        {
          price: {
            price: {
              displayValue: '£21.99',
              amount: '21.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£21.99',
              amount: '21.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£35.82',
              amount: '35.82',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£37.99',
              amount: '37.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£20.49',
              amount: '20.49',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£21.99',
              amount: '21.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£11.99',
              amount: '11.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£11.99',
              amount: '11.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£22.99',
              amount: '22.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£22.99',
              amount: '22.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£34.99',
              amount: '34.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£34.99',
              amount: '34.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
      ],
      reviews: {
        total: 1446,
        averageScore: 4.58,
        __typename: 'ProductReviews',
      },
      __typename: 'Product',
    },
    {
      sku: 10530657,
      url: '/sports-nutrition/impact-diet-whey/10530657.html',
      title: 'Impact Diet Whey',
      images: [
        {
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/10530657-1834620650702430.jpg',
          __typename: 'ProductImage',
        },
        {
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/10530657-1364620650788989.jpg',
          __typename: 'ProductImage',
        },
      ],
      variants: [
        {
          price: {
            price: {
              displayValue: '£24.99',
              amount: '24.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£24.99',
              amount: '24.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£56.99',
              amount: '56.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£56.99',
              amount: '56.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£109.99',
              amount: '109.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£109.99',
              amount: '109.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£7.99',
              amount: '7.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£7.99',
              amount: '7.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
      ],
      reviews: {
        total: 3867,
        averageScore: 4.32,
        __typename: 'ProductReviews',
      },
      __typename: 'Product',
    },
    {
      sku: 10529988,
      url: '/sports-nutrition/weight-gainer-blend/10529988.html',
      title: 'Weight Gainer Blend',
      images: [
        {
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/10529988-1004620647157420.jpg',
          __typename: 'ProductImage',
        },
        {
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/10529988-4504620647183469.jpg',
          __typename: 'ProductImage',
        },
      ],
      variants: [
        {
          price: {
            price: {
              displayValue: '£29.99',
              amount: '29.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£29.99',
              amount: '29.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£54.99',
              amount: '54.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£54.99',
              amount: '54.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£13.99',
              amount: '13.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£13.99',
              amount: '13.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
      ],
      reviews: { total: 534, averageScore: 4.06, __typename: 'ProductReviews' },
      __typename: 'Product',
    },
    {
      concession: {
        concessionCode: 'DuluxHeritage',
        __typename: 'Concession',
      },
      sku: 12899143,
      title: 'Dulux Heritage Matt Emulsion Paint - Waxed Khaki - 2.5L',
      url: '/dulux-heritage-matt-emulsion-paint-waxed-khaki-2.5l/12899143.html',
      images: [
        {
          thumbnail:
            'https://s1.thcdn.com/productimg/70/70/12899143-4844847684804688.png',
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/12899143-4844847684804688.png',
          original:
            'https://s1.thcdn.com/productimg/original/12899143-4844847684804688.png',
          __typename: 'ProductImage',
        },
        {
          thumbnail:
            'https://s1.thcdn.com/productimg/70/70/12899143-3324847684760654.png',
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/12899143-3324847684760654.png',
          original:
            'https://s1.thcdn.com/productimg/original/12899143-3324847684760654.png',
          __typename: 'ProductImage',
        },
        {
          thumbnail:
            'https://s1.thcdn.com/productimg/70/70/12899143-1544847684711196.png',
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/12899143-1544847684711196.png',
          original:
            'https://s1.thcdn.com/productimg/original/12899143-1544847684711196.png',
          __typename: 'ProductImage',
        },
        {
          thumbnail:
            'https://s1.thcdn.com/productimg/70/70/12899143-8474847684852778.png',
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/12899143-8474847684852778.png',
          original:
            'https://s1.thcdn.com/productimg/original/12899143-8474847684852778.png',
          __typename: 'ProductImage',
        },
        {
          thumbnail:
            'https://s1.thcdn.com/productimg/70/70/12899143-2004847684977254.jpg',
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/12899143-2004847684977254.jpg',
          original:
            'https://s1.thcdn.com/productimg/original/12899143-2004847684977254.jpg',
          __typename: 'ProductImage',
        },
        {
          thumbnail:
            'https://s1.thcdn.com/productimg/70/70/12899143-2114847685014688.jpg',
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/12899143-2114847685014688.jpg',
          original:
            'https://s1.thcdn.com/productimg/original/12899143-2114847685014688.jpg',
          __typename: 'ProductImage',
        },
        {
          thumbnail:
            'https://s1.thcdn.com/productimg/70/70/12899143-1024847685051504.jpg',
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/12899143-1024847685051504.jpg',
          original:
            'https://s1.thcdn.com/productimg/original/12899143-1024847685051504.jpg',
          __typename: 'ProductImage',
        },
        {
          thumbnail:
            'https://s1.thcdn.com/productimg/70/70/12899143-5674847684942865.jpg',
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/12899143-5674847684942865.jpg',
          original:
            'https://s1.thcdn.com/productimg/original/12899143-5674847684942865.jpg',
          __typename: 'ProductImage',
        },
        {
          thumbnail:
            'https://s1.thcdn.com/productimg/70/70/12899143-7144847685090939.png',
          largeProduct:
            'https://s1.thcdn.com/productimg/300/300/12899143-7144847685090939.png',
          original:
            'https://s1.thcdn.com/productimg/original/12899143-7144847685090939.png',
          __typename: 'ProductImage',
        },
      ],
      variants: [
        {
          price: {
            price: {
              displayValue: '£24.99',
              amount: '24.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£24.99',
              amount: '24.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
        {
          price: {
            price: {
              displayValue: '£56.99',
              amount: '56.99',
              __typename: 'MoneyValue',
            },
            rrp: {
              displayValue: '£56.99',
              amount: '56.99',
              __typename: 'MoneyValue',
            },
            __typename: 'ProductPrice',
          },
          __typename: 'ProductVariant',
        },
      ],
      reviews: { total: 534, averageScore: 4.06, __typename: 'ProductReviews' },
      __typename: 'Product',
    },
  ],
  alternateLinks: [
    {
      locale: 'en_NZ',
      url:
        'https://nz.myprotein.com/sports-nutrition/impact-whey-protein/12313105.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'nb_NO',
      url:
        'https://www.myprotein.no/sports-nutrition/whey-protein-myseprotein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'fr_FR',
      url:
        'https://fr.myprotein.com/nutrition-sportive/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'th_TH',
      url:
        'https://www.myprotein.co.th/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'fr_MA',
      url:
        'https://www.myprotein.co.ma.invalid/nutrition-sportive/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'de_AT',
      url:
        'https://www.myprotein.at/sporternahrung/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_IS',
      url:
        'https://site1-testweb-003.thehut.net/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'zh_TW',
      url:
        'https://www.myprotein.tw/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'in_ID',
      url:
        'https://site3-testweb-001.thehut.net/sports-nutrition/myprotein-impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'sl_SI',
      url:
        'https://si.myprotein.com/sports-nutrition/impact-whey-proteini/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_GB',
      url:
        'https://www.myprotein.com/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'iw_IL',
      url:
        'https://il.myprotein.com.invalid/sports-nutrition/myprotein-impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'it_IT',
      url:
        'https://www.myprotein.it/nutrizione-sportiva/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'pl_PL',
      url:
        'https://www.myprotein.pl/sports-nutrition/bialko-serwatkowe-impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_CA',
      url:
        'https://ca.myprotein.com/sports-nutrition/impact-whey-protein/10852500.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'ru_RU',
      url:
        'https://www.myprotein.ru/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_VN',
      url:
        'https://www.myprotein.com.vn.invalid/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'el_CY',
      url:
        'https://www.myprotein.com.cy/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_PK',
      url:
        'https://www.myprotein.com.pk/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_IL',
      url:
        'https://www.myprotein.co.il/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'pt_PT',
      url:
        'https://www.myprotein.pt/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'az_AZ',
      url:
        'https://www.myprotein.az.invalid/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_SG',
      url:
        'https://www.myprotein.com.sg/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'nl_NL',
      url:
        'https://nl.myprotein.com/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'et_EE',
      url:
        'https://www.myprotein.ee/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_ZA',
      url:
        'https://www.myprotein.co.za.invalid/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'sr_RS',
      url:
        'https://www.myprotein.rs/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_IE',
      url:
        'https://www.myprotein.ie/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'uk_UA',
      url:
        'https://www.myprotein.com.ua/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'fr_CA',
      url:
        'https://fr-ca.myprotein.com/nutrition-sportive/impact-whey-protein/10852500.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'el_GR',
      url:
        'https://www.myprotein.gr/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'cs_CZ',
      url:
        'https://www.myprotein.cz/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'nl_BE',
      url:
        'https://www.myprotein.be/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'lt_LT',
      url:
        'https://www.myprotein.lt/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'sk_SK',
      url:
        'https://www.myprotein.sk/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'ar_SA',
      url:
        'https://www.myprotein.com.sa/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'ko_KR',
      url:
        'https://www.myprotein.co.kr/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'hu_HU',
      url:
        'https://www.myprotein.hu/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_AU',
      url:
        'https://au.myprotein.com/sports-nutrition/impact-whey-protein/12313105.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'de_DE',
      url:
        'https://de.myprotein.com/sporternahrung/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'ar_AE',
      url:
        'https://site5-testweb-001.thehut.net/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'sv_SE',
      url:
        'https://www.myprotein.se/kosttillskott/vassleprotein-impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'is_IS',
      url:
        'https://www.myprotein.is.invalid/sports-nutrition/areynslu-mysuprotein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'ru_KZ',
      url:
        'https://kz.myprotein.com/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'ro_RO',
      url:
        'https://www.myprotein.ro/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'pt_BR',
      url:
        'https://www.myprotein.com.br/sports-nutrition/impact-whey-protein/10852500.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_HK',
      url:
        'https://www.myprotein.com.hk/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'lv_LV',
      url:
        'https://www.myprotein.lv/sports-nutrition/impact-sukalu-proteini/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_US',
      url:
        'https://us.myprotein.com/sports-nutrition/impact-whey-protein/10852500.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'es_ES',
      url:
        'https://www.myprotein.es/nutricion-deportiva/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_MY',
      url:
        'https://www.myprotein.com.my/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'hr_HR',
      url:
        'https://www.myprotein.hr/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'bs_BA',
      url:
        'https://www.myprotein.ba/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'fi_FI',
      url:
        'https://www.myprotein.fi/lisaravinteet/impact-whey-proteiini/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'da_DK',
      url:
        'https://www.myprotein.dk/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_IN',
      url:
        'https://www.myprotein.co.in/sports-nutrition/impact-whey-protein/11654605.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'de_CH',
      url:
        'https://www.myprotein.ch/sporternahrung/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'zh_CN',
      url:
        'https://www.myprotein.cn/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_AE',
      url:
        'https://www.myprotein.ae/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'vi_VN',
      url:
        'https://www.myprotein.com.vn/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'ja_JP',
      url:
        'https://www.myprotein.jp/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'bg_BG',
      url:
        'https://www.myprotein.bg/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
    {
      locale: 'en_PH',
      url:
        'https://www.myprotein.com.ph.invalid/sports-nutrition/impact-whey-protein/10530943.html',
      __typename: 'AlternateLink',
    },
  ],
  __typename: 'Product',
}

export const Product = (
  client: ApolloClient<NormalizedCacheObject>,
  { behaviours }: { behaviours: ClientBehaviours },
) => async (_parent, args: any) => {
  if (behaviours.override) {
    return {
      ...MOCK_PRODUCT,
      ...getProductPrice(MOCK_PRODUCT.variants),
      recommendations: getRecommendations(MOCK_PRODUCT.recommendations),
      productType:
        MOCK_PRODUCT.variants.length > 1
          ? ProductType.COMPLEX
          : ProductType.SIMPLE,
    }
  }

  const { data } = await client.query({
    query: product,
    variables: args,
  })

  if (!data?.product) {
    return null
  }

  const productType =
    (data.product.variants || []).length > 1
      ? ProductType.COMPLEX
      : ProductType.SIMPLE

  if (data.product?.sku === Number(args.sku)) {
    const variant =
      data.product?.variants?.find(
        (variant) => variant.sku === Number(args.sku),
      ) ||
      data.product?.defaultVariant ||
      data.product?.variants[0]

    return {
      ...data.product,
      ...getProductPrice([variant]),
      productType,
      externalIdentifier: variant?.externalIdentifier || '',
      recommendations: getRecommendations(data.product?.recommendations),
      inStock: variant?.inStock || false,
      variantCount: (data.product?.variants || []).length,
    }
  }

  if (data.product?.variants?.length > 0) {
    const variantProduct = data.product.variants.find(
      (varProduct: ProductVariant) => varProduct.sku === Number(args.sku),
    )

    if (variantProduct) {
      return {
        ...mergeVariantProduct(data.product, variantProduct),
        ...getProductPrice([variantProduct]),
        productType,
        externalIdentifier: data.product?.externalIdentifier || '',
        recommendations: getRecommendations(data.product?.recommendations),
        variantCount: (data.product?.variants || []).length,
        __typename: 'Product',
      }
    }
  }

  return {
    ...data.product,
    ...getProductPrice(data.product?.variants),
    productType,
    externalIdentifier: data.product?.externalIdentifier || '',

    recommendations: getRecommendations(data.product?.recommendations),
    variantCount: (data.product?.variants || []).length,
    __typename: 'Product',
  }
}

export const getRecommendations = (
  productRecommendations:
    | {
        sku?: number
        url?: string
        title?: string
        brand?: {
          name?: string
        }
        images?: ProductImage[]
        variants?: ProductVariant[]
        reviews?: ProductReviews
        map(param: (recommendation) => any): HorizonProduct[] | undefined
      }
    | null
    | undefined,
) => {
  let recommendations: HorizonProduct[] | undefined
  if (productRecommendations) {
    recommendations = productRecommendations.map((recommendation) => {
      return {
        ...recommendation,
        ...getProductPrice(recommendation.variants),
        productType:
          MOCK_PRODUCT.variants.length > 1
            ? ProductType.COMPLEX
            : ProductType.SIMPLE,
      }
    })
  }
  return recommendations
}

export const getProductPrice = (
  variants:
    | { price?: ProductPrice; gbpPrice: ProductPrice }[]
    | null
    | undefined,
) => {
  if (!variants || variants.length === 0) {
    return {}
  }

  if (variants.length === 1) {
    return {
      hasFromPrice: false,
      price: {
        displayValue: variants[0]?.price?.price?.displayValue,
        amount: variants[0]?.price?.price?.amount,
        __typename: 'MoneyValue',
      },
      gbpPrice: {
        displayValue: variants[0]?.gbpPrice?.price?.displayValue,
        amount: variants[0]?.gbpPrice?.price?.amount,
        __typename: 'MoneyValue',
      },
    }
  }

  const sortedVariantPrices = [...variants].sort(
    (a, b) =>
      parseFloat(a?.price?.price?.amount || '1') -
      parseFloat(b?.price?.price?.amount || '0'),
  )

  const lastProduct = sortedVariantPrices[variants.length - 1]
  const lowestPrice =
    (sortedVariantPrices[0].price &&
      sortedVariantPrices[0].price.price &&
      sortedVariantPrices[0].price.price.amount) ||
    '0'
  const highestPrice =
    (lastProduct.price &&
      lastProduct.price.price &&
      lastProduct.price.price.amount) ||
    '0'
  const hasFromPrice = lowestPrice < highestPrice

  return {
    hasFromPrice,
    price: {
      displayValue: sortedVariantPrices[0]?.price?.price?.displayValue,
      amount: sortedVariantPrices[0]?.price?.price?.amount,
      __typename: 'MoneyValue',
    },
    gbpPrice: {
      displayValue: sortedVariantPrices[0]?.gbpPrice?.price?.displayValue,
      amount: sortedVariantPrices[0]?.gbpPrice?.price?.amount,
      __typename: 'MoneyValue',
    },
  }
}
